import { createStore } from "vuex";

const store = createStore({
    state: {
        visible: true
    }
})

export default store;